// Generated by ReScript, PLEASE EDIT WITH CARE

import * as S from "sury/src/S.res.mjs";
import * as Reducer$LiteracyplanetTupperware from "../Reducer.res.mjs";
import * as ContextMaker$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/ContextMaker.res.mjs";

var kindSchema = S.union([
      S.schema(function (s) {
            return {
                    TAG: "HighlightResponseSets",
                    hasStem: s.m(S.bool),
                    marking: s.m(Reducer$LiteracyplanetTupperware.questionMarkingSchema)
                  };
          }),
      S.schema(function (s) {
            return {
                    TAG: "MultiChoiceResponseSets",
                    hasStem: s.m(S.bool),
                    marking: s.m(Reducer$LiteracyplanetTupperware.questionMarkingSchema)
                  };
          }),
      S.literal("GridMatchLeftToRight"),
      S.literal("GridMatchRightToLeft"),
      S.literal("InstructionAndHint")
    ]);

var apiSchema = S.schema(function (s) {
      return {
              numColumns: s.m(S.$$int),
              numRows: s.m(S.$$int),
              kind: s.m(kindSchema)
            };
    });

var S$1 = {
  name: "V3CustomTableContext"
};

var include = ContextMaker$LiteracyplanetClientFlags.Make(S$1);

var initialContext = include.initialContext;

var context = include.context;

var P = include.P;

var Provider = include.Provider;

var ContextMakerProviderNotFound = include.ContextMakerProviderNotFound;

var use = include.use;

export {
  kindSchema ,
  apiSchema ,
  S$1 as S,
  initialContext ,
  context ,
  P ,
  Provider ,
  ContextMakerProviderNotFound ,
  use ,
}
/* kindSchema Not a pure module */
